<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">
            <el-form-item label="标题" prop="name">
                <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="封面" prop="thumb">
                <el-row>
                    <div class="common-czm-uploadBox">
                        <div class="common-czm-uploadBox-img" v-if="form.thumb !== ''">
                            <el-image :src="form.thumb" :preview-src-list="[form.thumb]" fit="cover" />
                            <i class="el-icon-error delete-icon" @click.stop="deleteThumb"></i>
                        </div>
                        <div class="common-czm-uploadBox-upload-img"  @click="openUpload('image', 'thumb')">
                            <el-image :src="require('@/assets/img/upload_icon.png')" />
                        </div>
                    </div>
                </el-row>
            </el-form-item>
            <el-form-item label="轮播图" prop="images">
                <el-row>
                    <div class="common-czm-uploadBox">
                        <div class="common-czm-uploadBox-img" v-if="form.images" v-for="(item,index) in form.images">
                            <el-image :src="item" :preview-src-list="[item]" fit="cover" />
                            <i class="el-icon-error delete-icon" @click.stop="deleteImages(index)"></i>
                        </div>
                        <div class="common-czm-uploadBox-upload-img"  @click="openUpload('image', 'images')">
                            <el-image :src="require('@/assets/img/upload_icon.png')" />
                        </div>
                    </div>
                </el-row>
            </el-form-item>
            <el-form-item label="视频" prop="videos">
                <el-row>
                    <div class="common-czm-uploadBox">
                        <template v-if="form.videos">
                            <div class="common-czm-uploadBox-img" v-for="(item,index) in form.videos ">
                                <video :src="item.file_path" @click="showVideo(item.file_path,'video')"></video>
                                <i class="el-icon-error delete-icon" @click.stop="deleteVideo(index)"></i>
                            </div>
                        </template>
                        <div class="common-czm-uploadBox-upload-img"  @click="openUpload('video', 'videos')">
                            <el-image :src="require('@/assets/img/upload_icon.png')" />
                        </div>
                    </div>
                </el-row>
            </el-form-item>
            <el-form-item label="音频" prop="audios">
                <el-row>
                    <div class="common-czm-uploadBox">
                        <template v-if="form.videos">
                            <div class="common-czm-uploadBox-img" v-for="(item,index) in form.audios " @click="showVideo(item.file_path,'audio')">
                                <i class="el-icon-headset audio-icon"></i>
                                <i class="el-icon-error delete-icon" @click.stop="deleteAudio(index)"></i>
                            </div>
                        </template>
                        <div class="common-czm-uploadBox-upload-img"  @click="openUpload('audio', 'audios')">
                            <el-image :src="require('@/assets/img/upload_icon.png')" />
                        </div>
                    </div>
                </el-row>
            </el-form-item>
            <el-form-item label="简介" prop="remark">
                <el-input type="textarea" :rows="3"  v-model="form.remark" placeholder="请输入简介内容便于展示"></el-input>
            </el-form-item>
            <el-form-item label="详情" prop="content">
                <Editor :text="form.content" @get-content="contentChangeFunc" :width="600" ></Editor>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>
            <el-form-item label="状态" prop="sort">
                <el-select v-model="form.status" placeholder="请选择状态">
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                </el-select>
                <div class="tips">启用禁用此条数据</div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
        <Upload v-if="isupload" :config.sync="file_config" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        <!--链接选择-->
        <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">选择链接</Setlink>
        <el-dialog
            title="预览"
            :visible.sync="showVideDialogVisible"
            width="40%"
            :before-close="VideDialogClose"
            append-to-body
        >
      <span class="common-czm-upload-show-video">
        <video :src="viewVideoUrl" controls class="common-czm-upload-show-video" v-if="viewType === 'video'"></video>
        <audio :src="viewVideoUrl" controls class="common-czm-upload-show-video" v-else></audio>
      </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
import {dynamicSave, dynamicDetail} from '@/api/education';
import Upload from '@/components/file/Upload';
import Setlink from '@/components/setlink/SetTab';
import Editor from "@/components/tsk/editor.vue";

export default {
    components: {Editor, Upload, Setlink },
    data() {
        return {
            title: '',
            form: {
                title: '',
                content:'',
                remark:'',
                thumb: '',
                images:[],
                videos:[],
                audios:[],
                sort: 1,
                status:1,
            },
            file_path: '',
            /*左边长度*/
            formLabelWidth: '120px',
            /*是否显示*/
            dialogFormVisible: false,
            /*是否正在提交*/
            submit_loading: false,
            /*链接选择*/
            is_linkset: false,
            // 验证
            formRules: {
                title: [{
                    required: true,
                    message: '请输入广告名称',
                    trigger: 'blur'
                }],
                image_id: [{
                    required: true,
                    message: '请上传分类图片',
                    trigger: 'blur'
                }],
                sort: [{
                    required: true,
                    message: '分类排序不能为空'
                }, {
                    type: 'number',
                    message: '分类排序必须为数字'
                }]
            },

            /*上传图片*/
            isupload: false,
            file_config:{},
            file_name:'',
            //视频预览地址
            viewVideoUrl:'',
            viewType:'',
            //视频预览开关
            showVideDialogVisible:false,
        };
    },
    props: ['fetch-data'],
    created() {

    },
    methods: {
        //删除图片
        deleteThumb(){
            this.form.thumb = ''
        },
        deleteImages(index){
            this.form.images.splice(index,1)
        },
        //删除视频
        deleteVideo(index){
            this.form.videos.splice(index,1)
        },
        deleteAudio(index){
            this.form.audios.splice(index,1)
        },
        showVideo(url,showType = ''){
            this.viewVideoUrl = url;
            this.viewType = showType;
            this.showVideDialogVisible = true;
        },
        VideDialogClose(){
            this.showVideDialogVisible = false;
            this.viewVideoUrl = ''
            this.viewType = ''
        },

        contentChangeFunc(val){
            this.form.content = val
        },
        showDialog(row) {
            if (!row) {
                this.title = '添加'
            } else {
                this.title = '编辑'
                this.form.id = row.id
                this.getDetail()
            }
            this.dialogFormVisible = true
        },
        // 关闭
        close() {
            this.$refs['form'].resetFields()
            this.form = this.$options.data().form
            this.dialogFormVisible = false
        },
        // 保存
        save() {
            this.$refs['form'].validate(async (valid) => {
                if (valid) {
                    this.submit_loading = true;
                    dynamicSave(this.form).then((result)=>{
                        this.$message({message: result.msg, type: 'success'});
                        this.$emit('fetch-data')
                        this.submit_loading = false;
                        this.close()
                    }).catch(()=>{
                        this.submit_loading = false;
                    })
                }
            })
        },
        getDetail(){
            dynamicDetail({id: this.form.id}).then((result)=>{
                this.form = Object.assign({}, result.data)
            })
        },

        // 图片上传
        openUpload(file_type, file_name) {
            this.file_name = file_name;
            if (file_name === 'thumb') { // 封面图
                this.file_config = {
                    total: 1,
                    file_type: 'image',
                    check_count:true
                };
            }
            if(file_name === 'images'){
                if (this.form.images.length >= 10){
                    this.$message.error("您最多只能上传10张图片")
                    return false;
                }
                this.file_config = {
                    total: 10 - this.form.images.length,
                    file_type: 'image',
                    check_count:true
                };
            }

            if(file_name === 'videos'){
                if (this.form.videos.length >= 10){
                    this.$message.error("您最多只能上传10个视频")
                    return false;
                }
                this.file_config = {
                    total: 10 - this.form.videos.length,
                    file_type: 'video',
                    check_count:true
                };
            }

            if(file_name === 'audios'){
                if (this.form.audios.length >= 10){
                    this.$message.error("您最多只能上传10个音频")
                    return false;
                }
                console.log(10 - this.form.audios.length,444)
                this.file_config = {
                    total: 10 - this.form.audios.length,
                    file_type: 'audio',
                    check_count:true
                };
            }

            if(file_name === 'file'){
                this.file_config = {
                    total: 1,
                    file_type: 'file'
                };
            }
            this.isupload = true;
        },
        /*获取图片*/
        returnImgsFunc(e) {
            if (this.file_name === 'thumb' ){
                if (e != null && e.length > 0) {
                    this.form.thumb = e[0].file_path;
                }
            }
            if (this.file_name === 'images'){
                let file_path_arr = [];
                if (e != null && e.length > 0) {
                    for (let i = 0; i < e.length; i++) {
                        file_path_arr.push(e[i].file_path);
                    }
                    this.form.images = this.form.images.concat(file_path_arr);
                }
            }
            if (this.file_name === 'videos'){
                console.log(e,44)
                if (e != null && e.length > 0) {
                    this.form.videos = this.form.videos.concat(e);
                }
            }
            if (this.file_name === 'audios'){
                console.log(e)
                if (e != null && e.length > 0) {
                    this.form.audios = this.form.audios.concat(e);
                }
            }

            this.isupload = false;
        },
        /*选择链接*/
        changeLink() {
            this.is_linkset = true;
        },
        /*获取链接并关闭弹窗*/
        closeLinkset(e) {
            this.is_linkset = false;
            this.form.link_url = e ? '/' + e.url : '';
            this.form.name = e.name;
        },
    }
};
</script>

<style scoped>
.tips {
    color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/education/dynamic/edit.vue